module.exports = __webpack_public_path__ + "img/theproject.6cfa9cc5.png";